(function () {
  'use strict';

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function setDrawer(open) {
    var drawer = qs('[data-mobile-drawer]');
    var overlay = qs('[data-drawer-overlay]');
    var toggle = qs('[data-menu-toggle]');
    if (!drawer || !overlay || !toggle) return;
    drawer.classList.toggle('is-open', open);
    overlay.hidden = !open;
    document.body.classList.toggle('drawer-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  }

  function initHeader() {
    var menuToggle = qs('[data-menu-toggle]');
    var close = qs('[data-menu-close]');
    var overlay = qs('[data-drawer-overlay]');
    if (menuToggle) menuToggle.addEventListener('click', function () { setDrawer(true); });
    if (close) close.addEventListener('click', function () { setDrawer(false); });
    if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setDrawer(false);
    });
  }

  function formatMoney(cents, format) {
    var value = (Number(cents || 0) / 100).toFixed(2);
    if (format && format.indexOf('{{ amount_no_decimals }}') !== -1) {
      value = Math.round(Number(cents || 0) / 100).toString();
    }
    return (format || ('$' + '{{ amount }}')).replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, value);
  }

  function initProduct(root) {
    var json = qs('[data-product-json]', root);
    var form = qs('.product-form', root);
    if (!json || !form) return;

    var product;
    try {
      product = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    var idInput = qs('[name="id"]', form);
    var addButton = qs('[data-add-to-cart]', form);
    var addText = qs('[data-add-text]', form);
    var price = qs('[data-product-price]', root);
    var compare = qs('[data-compare-price]', root);
    var moneyFormat = root.getAttribute('data-money-format') || ('$' + '{{ amount }}');

    function selectedOptions() {
      return qsa('[data-option-group]', form).map(function (group) {
        var checked = qs('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function updateVariant() {
      var options = selectedOptions();
      var variant = product.variants.find(function (item) {
        return item.options.every(function (option, index) { return option === options[index]; });
      });

      if (!variant) {
        addButton.disabled = true;
        addText.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price, moneyFormat);

      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? addButton.getAttribute('data-available-text') : 'Sold out';

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      if (variant.featured_media) {
        var media = qs('[data-media-id="' + variant.featured_media.id + '"]', root);
        if (media && window.innerWidth < 990) media.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    qsa('[data-option-input]', form).forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  }

  function initQuantity() {
    qsa('[data-quantity]').forEach(function (wrap) {
      var input = qs('input', wrap);
      if (!input) return;
      qsa('button', wrap).forEach(function (button) {
        button.addEventListener('click', function () {
          var step = button.getAttribute('data-quantity-change') === 'increase' ? 1 : -1;
          var min = Number(input.min || 0);
          var next = Math.max(min, Number(input.value || 0) + step);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initPredictiveSearch() {
    var input = qs('[data-search-input]');
    var results = qs('[data-search-results]');
    if (!input || !results || !window.Shopify || !window.Shopify.routes) return;
    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        var url = window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var section = qs('#shopify-section-predictive-search', html);
            results.innerHTML = section ? section.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  function initCatalog(root) {
    var button = qs('[data-load-more]', root);
    var grid = qs('[data-product-grid]', root);
    if (!button || !grid) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      button.textContent = 'Loading';

      fetch(button.href)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var page = new DOMParser().parseFromString(text, 'text/html');
          var nextGrid = qs('[data-product-grid]', page);
          var nextButton = qs('[data-load-more]', page);

          if (!nextGrid) throw new Error('Product grid not found');

          while (nextGrid.firstElementChild) {
            grid.appendChild(nextGrid.firstElementChild);
          }

          if (nextButton) {
            button.href = nextButton.href;
            button.textContent = 'Load more';
            button.classList.remove('is-loading');
          } else {
            button.parentNode.remove();
          }
        })
        .catch(function () {
          window.location.href = button.href;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initQuantity();
    initPredictiveSearch();
    qsa('[data-product-root]').forEach(initProduct);
    qsa('[data-catalog-root]').forEach(initCatalog);
  });
})();
